import { ImageModel } from '../../../../utils/props-mappings'

export enum CardTypes {
  Loyalty = 'loyalty',
  Voucher = 'voucher'
}

export enum MgmDataTypes {
  GsAction = 'godson-action',
  GfAction = 'godfather-action'
}

export type CardModelProps = {
  message: string
  image: ImageModel
  copyMessage: string
}

export type GodLinkAction = {
  redeemedLabel: string
}

export type GodFatherAction = {
  expiresOnLabel: string
  expiredOnLabel: string
} & GodLinkAction

export type DashboardModelProps = {
  id: string
  general: {
    display: MgmDataTypes
    referralCode: {
      label: string
      progressLabel: string
    }
    loyaltyCard: CardModelProps
    voucherCard: CardModelProps
  }
  gfAction: GodFatherAction
  gsAction: GodLinkAction
}
